import DeepLinkAPIs from './DeepLink';
import KeyboardAPIs from './Keyboard';
const WebModuleAPIs = {
    DeepLink: DeepLinkAPIs,
    Keyboard: KeyboardAPIs,
};
export default WebModuleAPIs;
